import React from "react";
import DayRow from "./DayRow";
import FreeDayRow from "./FreeDayRow";

export default function ScheduleDays({
    filteredDates,
    todayStr,
    eventsByDate,
    employees,
    updateEventStaff,
    updateEventColor,
    columnAssignments,
    showColorPicker,
    setShowColorPicker,
    unavailableByDate,
    toggleUnavailable,
    maxWidth,
    isAdmin,
    copyStaffToAllDates,
    updateNeededForEvent,
    rowRefs,
    getAssignedNamesForDate,
    getUnavailableNamesForDate,
    activeCalendarId,
    allEventsForDate,
    eventsByDateFull,
    renderFreeForEmpty = false,
    dragScale = 1,
    // mobile: obsługa powiększania pojedynczego dnia
    expandedDay,
    onDayClick,
    onCloseExpanded,
    isPortalView = false,
}) {
    const hiddenStyle = { display: "none" };

    return (
        <div className="space-y-2">
            {filteredDates.map((date) => {
                const dayEvents = eventsByDate[date] || [];
                const isDayExpanded = expandedDay === date;
                const shouldHideOriginal = isDayExpanded && !isPortalView;
                const wrapperStyle = shouldHideOriginal ? hiddenStyle : undefined;
                const isExpandedForRender = isPortalView && isDayExpanded;

                // 🔹 Zapisujemy referencję pod kluczem daty
                const setRef = (el) => {
                    if (!rowRefs?.current) return;
                    if (el) {
                        rowRefs.current[date] = el;
                        return;
                    }
                    const current = rowRefs.current[date];
                    if (current && current.isConnected) return;
                    delete rowRefs.current[date];
                };

                if (renderFreeForEmpty && dayEvents.length === 0) {
                    return (
                        <div
                            key={`free-${date}`}
                            id={`day-${date}`}
                            data-day-anchor={date}
                            ref={setRef}
                            className={isExpandedForRender ? "day-card-expanded" : ""}
                            style={wrapperStyle}
                            onClick={(e) => {
                                e.stopPropagation();
                                // W trybie expanded nie wywołuj onDayClick
                                if (isExpandedForRender) return;
                                
                                // Sprawdź, czy kliknięcie było w interaktywny element
                                const target = e.target;
                                const isInteractive = 
                                    target.closest('button') || 
                                    target.closest('.staff-item') || 
                                    target.closest('.event-box') ||
                                    target.closest('[class*="AddStaffPicker"]') ||
                                    target.closest('[class*="EventActionsMenu"]') ||
                                    target.closest('[class*="StaffMenu"]');
                                
                                // Otwórz powiększenie tylko jeśli kliknięcie było w pustą przestrzeń
                                if (!isInteractive && onDayClick) {
                                    onDayClick(date);
                                }
                            }}
                        >
                            <FreeDayRow
                                date={date}
                                todayStr={todayStr}
                                employees={employees}
                                unavailable={unavailableByDate[date] || []}
                                toggleUnavailable={(name) => toggleUnavailable(date, name)}
                                isExpanded={isExpandedForRender}
                            />
                        </div>
                    );
                }

                return (
                    <div
                        key={date}
                        id={`day-${date}`}
                        data-day-anchor={date}
                        ref={setRef}
                        className={isExpandedForRender ? "day-card-expanded" : ""}
                        style={wrapperStyle}
                        onClick={(e) => {
                            e.stopPropagation();
                            // W trybie expanded nie wywołuj onDayClick, aby kliknięcie na kartę nie zamykało jej
                            if (isExpandedForRender) return;
                            
                            // Sprawdź, czy kliknięcie było w interaktywny element
                            const target = e.target;
                            const isInteractive = 
                                target.closest('button') || 
                                target.closest('.staff-item') || 
                                target.closest('.event-box') ||
                                target.closest('.add-staff-picker-panel') ||
                                target.closest('[class*="AddStaffPicker"]') ||
                                target.closest('[class*="EventActionsMenu"]') ||
                                target.closest('[class*="StaffMenu"]') ||
                                target.closest('[class*="Droppable"]') ||
                                target.closest('[class*="Draggable"]') ||
                                target.closest('input');
                            
                            // Otwórz powiększenie tylko jeśli kliknięcie było w pustą przestrzeń
                            if (!isInteractive && onDayClick) {
                                onDayClick(date);
                            }
                        }}
                    >
                        <DayRow
                            date={date}
                            todayStr={todayStr}
                            events={dayEvents}
                            layoutFrozen={shouldHideOriginal}
                            employees={employees}
                            updateEventStaff={isAdmin ? updateEventStaff : () => { }}
                            updateEventColor={isAdmin ? updateEventColor : () => { }}
                            columnAssignments={columnAssignments}
                            showColorPicker={showColorPicker}
                            setShowColorPicker={setShowColorPicker}
                            unavailable={unavailableByDate[date] || []}
                            toggleUnavailable={(name) => toggleUnavailable(date, name)}
                            forcedWidth={maxWidth > 0 ? `${maxWidth}px` : "auto"}
                            isAdmin={isAdmin}
                            copyStaffToAllDates={isAdmin ? copyStaffToAllDates : () => { }}
                            updateNeededForEvent={isAdmin ? updateNeededForEvent : () => { }}
                            getAssignedNamesForDate={getAssignedNamesForDate}
                            getUnavailableNamesForDate={getUnavailableNamesForDate}
                            activeCalendarId={activeCalendarId}
                            allEventsForDay={
                                typeof allEventsForDate === "function" ? allEventsForDate(date) : []
                            }
                            eventsByDateFull={eventsByDateFull}
                            unavailableByDate={unavailableByDate}
                            dragScale={dragScale}
                            isExpanded={isExpandedForRender}
                            onCloseExpanded={onCloseExpanded}
                        />
                    </div>
                );
            })}
        </div>
    );
}
